import api from '~/api';
import {
  FederalTaxClassificationResponse,
  IdentificationTypeResponse,
  PartnerResponse,
} from '../dtos/partnerResponse';
import {
  FederalTaxClassification,
  Partner,
  TaxPayerIdentificationType,
} from '../models/partner.model';

const FederalTaxClassificationMap: Record<
  FederalTaxClassificationResponse,
  FederalTaxClassification
> = {
  individual: 'Individual/sole Proprietor',
  c_corporation: 'C Corporation',
  s_corporation: 'S Corporation',
  partnership: 'Partnership',
  trust_estate: 'Trust/Estate',
  llc_c_corporation: 'LLC classified as C Corporation',
  llc_s_corporation: 'LLC classified as S Corporation',
  llc_partnership: 'LLC classified as Partnership',
  other: 'Other',
};

const TaxIdentificationTypeMap: Record<IdentificationTypeResponse, TaxPayerIdentificationType> = {
  ssn: 'SSN',
  fein: 'EIN',
};

export async function getPartnerDetails(partnerId: string): Promise<Partner> {
  const { data } = await api.get<PartnerResponse>(`v1/partner/${partnerId}`);
  return new Partner(
    data.name,
    data.dba,
    TaxIdentificationTypeMap[data.identification_type],
    data.identification_number,
    FederalTaxClassificationMap[data.federal_tax_classification],
    { ...data.address, address2: data.address.address2 || '' }
  );
}
